import React, { useState, useEffect } from 'react';
import Config from '../Config'
import axios from 'axios';
import logos from '../layout/pageheader.jpeg'
import ReactTimeAgo from 'react-time-ago'

function Changelog() {
    const [changeLogs, setchangeLogs] = useState([])

    useEffect(async () => {
        const fetchPosts = async () => {
            const res = await axios.get(new Config().BaseURL() + 'category/fetchchangelog');
            setchangeLogs(res.data);

        };

        fetchPosts();
    }, [])




    return (
        <div>
            <div class="hero-section bg_img style-three" style={{ backgroundImage: `url(${logos})` }}>
                <div class="container">
                    <div class="section-header cl-white">
                        <h2 class="title">Changelog</h2>
                        <p>Discover new features, bug fixes and update releases from SupportHQ</p>
                    </div>
                </div>
            </div>
            <section class="changelog-section padding-bottom mt--187 pos-rel">
                <div class="container">
                    <div class="changelog-wrapper">
                        
                        {
                            changeLogs.map(itm => (
                                <div class="changelog-item">
                                    {(itm.changetype == "3") ? <span class="update-button bug">Bug Fix</span> : (itm.changetype == "2") ? <span class="update-button">Update</span> : <span class="update-button feature">Feature</span>}
                                    <h5 class="title">{itm.title}</h5>
                                    <span class="date"><ReactTimeAgo date={(itm.createdon ==undefined)?new Date():itm.createdon} /> </span>
                                    <p>{itm.description}</p>
                                </div>
                            ))
                        }

                       
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Changelog;
